export const STALE_CHUNK_RELOAD_KEY = 'tydy:stale-chunk-reload'

type VitePreloadErrorEvent = Event & {
  payload?: unknown
}

const errorFingerprint = (payload: unknown) => {
  if (payload instanceof Error) return payload.message
  if (typeof payload === 'string') return payload
  return 'unknown-vite-preload-error'
}

export function installStaleChunkRecovery() {
  let isReloading = false

  const handlePreloadError = (rawEvent: Event) => {
    const event = rawEvent as VitePreloadErrorEvent
    const fingerprint = errorFingerprint(event.payload)

    if (isReloading || sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) === fingerprint) {
      return
    }

    isReloading = true
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, fingerprint)
    event.preventDefault()
    window.location.reload()
  }

  window.addEventListener('vite:preloadError', handlePreloadError)

  return () => window.removeEventListener('vite:preloadError', handlePreloadError)
}
